"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var cb_popover_1 = require("@creditornot/cb-popover");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var DatePickerPopover = function (_a) {
    var children = _a.children, className = _a.className, content = _a.content, contentZIndex = _a.contentZIndex, disabled = _a.disabled, onCloseStart = _a.onCloseStart, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, portalElement = _a.portalElement, rendering = _a.rendering, style = _a.style;
    var _c = __read((0, react_1.useState)(false), 2), popoverOpen = _c[0], setPopoverOpen = _c[1];
    return (react_1.default.createElement(cb_popover_1.Popover, { content: typeof content === 'function'
            ? content({
                disabled: disabled,
                closePopover: function () { return setPopoverOpen(false); },
                openPopover: function () { return setPopoverOpen(true); },
                isOpen: popoverOpen,
            })
            : content, offset: 4, onCloseStart: onCloseStart, onOpenChange: setPopoverOpen, open: disabled ? false : popoverOpen, placement: placement, portalElement: portalElement, renderArrow: false, rendering: rendering, zIndex: contentZIndex }, function (_a) {
        var refProps = _a.refProps;
        return (react_1.default.createElement(Root, __assign({}, refProps, { className: className, style: style }), children({
            disabled: disabled,
            isOpen: popoverOpen,
            closePopover: function () { return setPopoverOpen(false); },
            openPopover: function () { return setPopoverOpen(true); },
        })));
    }));
};
exports.default = DatePickerPopover;
var templateObject_1;
//# sourceMappingURL=DatePickerPopover.js.map